import { Control, Controller, FieldErrors } from 'react-hook-form';
import { InputText } from '@ui/src';
import { CurrencyItem } from '../../hoc/currencies/types';

import cn from './currencies.module.css';

interface CurrencyFormProps {
  control: Control<CurrencyItem>;
  errors: FieldErrors<CurrencyItem>;
}

const CurrencyForm = ({ control, errors }: CurrencyFormProps) => (
  <div className={cn.currencyForm}>
    <div className={cn.currencyFormGroupFlex}>
      <Controller
        control={control}
        name="code"
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            placeholder="Enter Num. code"
            onChange={onChange}
            value={value?.toString()}
            title="Numeric code"
            error={errors?.code?.message}
            labelClassName={cn.currencyFormInputLabel}
            disabled
          />
        )}
      />
      <Controller
        control={control}
        name="name"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            placeholder="Enter Character code"
            onChange={onChange}
            value={value}
            title="Character code"
            error={errors?.name?.message}
            labelClassName={cn.currencyFormInputLabel}
            disabled
          />
        )}
      />
    </div>
    <div className={cn.currencyFormGroup}>
      <Controller
        control={control}
        name="description"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            placeholder="Full name of the currency"
            onChange={onChange}
            value={value}
            title="Description"
            error={errors?.description?.message}
            disabled
          />
        )}
      />
    </div>
    <div className={cn.currencyFormGroup}>
      <Controller
        control={control}
        name="decimals"
        render={({ field: { onChange, value, name } }) => (
          <InputText
            title="Precesion"
            name={name}
            placeholder="Enter a multiplier value"
            onChange={onChange}
            value={value?.toString()}
            error={errors?.decimals?.message}
            disabled
          />
        )}
      />
    </div>
  </div>
);

export default CurrencyForm;
